import { render, staticRenderFns } from "./RehabCoursesPerson.vue?vue&type=template&id=013143f0&scoped=true"
import script from "./RehabCoursesPerson.vue?vue&type=script&lang=js"
export * from "./RehabCoursesPerson.vue?vue&type=script&lang=js"
import style0 from "./RehabCoursesPerson.vue?vue&type=style&index=0&id=013143f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013143f0",
  null
  
)

export default component.exports